import {
  CREATE_FORMULAIRE_REQUEST,
  CREATE_FORMULAIRE_SUCCESS,
  CREATE_FORMULAIRE_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  formulaire: null,
  error: null,
};

const FormBuilderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_FORMULAIRE_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_FORMULAIRE_SUCCESS:
      return {
        ...state,
        loading: false,
        formulaire: action.payload,
        error: null,
      };

    case CREATE_FORMULAIRE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default FormBuilderReducer;
